module.exports = __webpack_public_path__ + "static/media/m-1-03.ac0394aa.svg";